var _desc, _defs, _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReelresume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "ReelResume Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Rounded tile with a film strip and a document to suggest video-style resumes.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grr",
    x1: 64,
    y1: 64,
    x2: 448,
    y2: 448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59E0B"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 448,
    height: 448,
    rx: 96,
    fill: "url(#grr)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(96 148)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 216,
    rx: 16,
    fill: "white",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 20,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 68,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 116,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 164,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 20,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 68,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 116,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 164,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 24,
    width: 96,
    height: 168,
    rx: 8,
    fill: "#E5E7EB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(272 164)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 144,
    height: 184,
    rx: 12,
    fill: "white",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 36,
    width: 96,
    height: 12,
    rx: 6,
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 64,
    width: 84,
    height: 12,
    rx: 6,
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 92,
    width: 104,
    height: 12,
    rx: 6,
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 120,
    width: 78,
    height: 12,
    rx: 6,
    fill: "#E5E7EB"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelresume);
export default __webpack_public_path__ + "static/media/reelresume.57192d30ed0328fb259b33cd1c4e121b.svg";
export { ForwardRef as ReactComponent };